var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94186 21.5722C10.03 20.1713 10.3654 18.8376 10.905 17.6143C9.1159 17.4483 7.49279 16.7041 6.22756 15.5717L7.78216 13.8347C8.81395 14.7583 10.1737 15.3184 11.667 15.3184C11.8724 15.3184 12.075 15.3078 12.2743 15.2872C14.2626 12.66 17.3385 10.9017 20.8319 10.6821C20.0228 6.35669 16.2272 3.083 11.667 3.083C6.51734 3.083 2.34277 7.25758 2.34277 12.4072C2.34277 16.9674 5.61645 20.7631 9.94186 21.5722ZM19.8528 13.1485C16.0832 13.852 13.1117 16.8235 12.4082 20.593L19.8528 13.1485ZM23.3222 12.4072C23.3222 12.6026 23.3174 12.7969 23.3078 12.9899L12.2497 24.0481C12.0567 24.0576 11.8624 24.0624 11.667 24.0624C5.22994 24.0624 0.0117188 18.8441 0.0117188 12.4072C0.0117188 5.97018 5.22994 0.751953 11.667 0.751953C18.1039 0.751953 23.3222 5.97018 23.3222 12.4072ZM9.3359 10.0761C9.3359 11.0417 8.55317 11.8244 7.58762 11.8244C6.62207 11.8244 5.83933 11.0417 5.83933 10.0761C5.83933 9.11058 6.62207 8.32785 7.58762 8.32785C8.55317 8.32785 9.3359 9.11058 9.3359 10.0761ZM17.4946 10.0761C17.4946 11.0417 16.7118 11.8244 15.7463 11.8244C14.7808 11.8244 13.998 11.0417 13.998 10.0761C13.998 9.11058 14.7808 8.32785 15.7463 8.32785C16.7118 8.32785 17.4946 9.11058 17.4946 10.0761Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiBtnIcon);
export default __webpack_public_path__ + "static/media/EmojiBtnIcon.0f097f2939beece308efa5c53ac6401d.svg";
export { ForwardRef as ReactComponent };